/** @format */

import { lazy } from "react";
import { Outlet } from "react-router-dom";
import { GuestGuard } from "src/guards/guest-guard";
import { IssuerGuard } from "src/guards/issuer-guard";
import { Layout as AuthLayout } from "src/layouts/auth/modern-layout";
import { Issuer } from "src/utils/auth";

// Firebase
const LoginPage = lazy(() => import("src/pages/auth/login"));
const ForgotPage = lazy(() => import("src/pages/auth/forgot"));
const RegisterPage = lazy(() => import("src/pages/auth/register"));
const OtpVerifyPage = lazy(() => import("src/pages/auth/otp-verify"));

export const authRoutes = [
  {
    path: "auth",
    element: (
      <IssuerGuard issuer={Issuer.Firebase}>
        <GuestGuard>
          <AuthLayout>
            <Outlet />
          </AuthLayout>
        </GuestGuard>
      </IssuerGuard>
    ),
    children: [
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "forgot",
        element: <ForgotPage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        path: "otp",
        element: <OtpVerifyPage />,
      },
    ],
  },
];
